import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import IDS from '../__tests__/ids';
import { NoStudentsAlert } from '../NoDataAlerts';
import './styles.scss';

/**
 * Show the students container for each section.
 * This contains the name of the students who watched and not watched the AP Daily video.
 * */
const StudentsContainer = ({
  className: parentClassName,
  watchedStudents,
  unwatchedStudents,
  showContainer,
}) => {
  const hasNoStudent = isEmpty(watchedStudents) && isEmpty(unwatchedStudents);
  return (
    <div
      className={cn('watched-students-container flex-row', parentClassName, {
        show: showContainer,
      })}
      data-test-id={IDS.STUDENTS_CONTAINER}
    >
      {hasNoStudent ? (
        <div className="no-students" data-test-id="no-students-text">
          <NoStudentsAlert />
        </div>
      ) : (
        <Fragment>
          <div className="fixed-width" />
          <div className="flex-column fixed-width">
            {unwatchedStudents.map(({ firstName, lastName }, index) => (
              <div
                key={`${index}${firstName}${lastName}`}
                className="student_name"
                data-test-id={IDS.UNWATCHED_STUDENT}
              >
                {firstName} {lastName}
              </div>
            ))}
          </div>
          <div className="flex-column fixed-width">
            {watchedStudents.map(({ firstName, lastName }, index) => (
              <div
                key={`${index}${firstName}${lastName}`}
                className="student_name"
                data-test-id={IDS.WATCHED_STUDENT}
              >
                {firstName} {lastName}
              </div>
            ))}
          </div>
          <div className="dummy-container" />
        </Fragment>
      )}
    </div>
  );
};

StudentsContainer.displayName = 'StudentsContainer';

StudentsContainer.propTypes = {
  className: PropTypes.string,
  watchedStudents: PropTypes.array,
  unwatchedStudents: PropTypes.array,
  showContainer: PropTypes.bool,
};

StudentsContainer.defaultProps = {
  className: '',
  watchedStudents: [],
  unwatchedStudents: [],
  showContainer: false,
};

export default StudentsContainer;
